import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS } from "config/constant/endpoints.config";
import { Paginator } from "types/interfaces";
import { injectParamsPaginator } from "utils/helpers/api-url";
import { baseQueryWithReauth } from "../rtkBaseQuery";

export const statisticsExpeditionModeApi = createApi({
  reducerPath: "statisticsExpeditionModeApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["StatisticExpeditionMode"],
  endpoints: (builder) => ({
    getExpeditionModeStatistics: builder.mutation({
      query: ({
        start_date,
        end_date
      }: {start_date?:number,end_date?:number}) => ({
        url: `/stats/modes`,
        method: "POST",
        body:start_date && end_date? {  start_date,
            end_date,
           }:{},
      }),
      invalidatesTags: ["StatisticExpeditionMode"],
    }),
    getAllExpeditionModeStatistics: builder.mutation({
        query: ({
          start_date,
          end_date
        }: {start_date?:number,end_date?:number}) => ({
          url: `/stats/allmodes`,
          method: "POST",
          body:start_date && end_date? {  start_date,
              end_date,
             }:{},
        }),
        invalidatesTags: ["StatisticExpeditionMode"],
      }),
  })
})

export const { useGetAllExpeditionModeStatisticsMutation,useGetExpeditionModeStatisticsMutation} =statisticsExpeditionModeApi;
